export enum ResourceType {
	Unknown = 0,
	Named = 1,
	Generic = 2,
	Category = 3,
	Team = 4,
	WorkProfile = 5,
	Pool = 6
}